unit UInstanceModel;

interface

uses
  Js;

type
  TInstanceModel = class
  private
    FErstelltVon: string;
    FInhalt: string;
    FErstelltAm: TDateTime;
    procedure ClearValues;
    procedure SetValues(Json: string); overload;
    procedure SetValues(Obj: TJsObject); overload;
    procedure SetErstelltAm(const Value: TDateTime);
    procedure SetErstelltVon(const Value: string);
    procedure SetInhalt(const Value: string);
  public
    constructor Create; overload;
    constructor Create(Json: string); overload;
    property ErstelltAm: TDateTime read FErstelltAm write SetErstelltAm;
    property ErstelltVon: string read FErstelltVon write SetErstelltVon;
    property Inhalt: string read FInhalt write SetInhalt;
  end;

implementation

uses
  System.SysUtils;

{ TInstanceModel }

procedure TInstanceModel.ClearValues;
begin
  Self.ErstelltAm := 0;
  Self.ErstelltVon := '';
  Self.Inhalt := '';
end;

constructor TInstanceModel.Create(Json: string);
begin
  Self.SetValues(Json);
end;

constructor TInstanceModel.Create;
begin
  Self.ClearValues;
end;

procedure TInstanceModel.SetErstelltAm(const Value: TDateTime);
begin
  FErstelltAm := Value;
end;

procedure TInstanceModel.SetErstelltVon(const Value: string);
begin
  FErstelltVon := Value;
end;

procedure TInstanceModel.SetInhalt(const Value: string);
begin
  FInhalt := Value;
end;

procedure TInstanceModel.SetValues(Obj: TJsObject);
begin
  Self.ClearValues;
  if Obj['ErstelltAm'] <> nil then
    Self.ErstelltAm := StrToDateTime(string(Obj['ErstelltAm']));
  if Obj['ErstelltVon'] <> nil then
    Self.ErstelltVon := string(Obj['ErstelltVon']);
  if Obj['Inhalt'] <> nil then
    Self.Inhalt := string(Obj['Inhalt']);
end;

procedure TInstanceModel.SetValues(Json: string);
var
  Obj: TJsObject;
begin
  Obj := TJsJson.parseObject(Json);
  Self.SetValues(Obj);
end;

end.
